import React, {createContext, useContext, useEffect, useState} from 'react';
import {IntlProvider} from 'react-intl';

export const messages = {
    en: {
        'cart_addToCart': 'Add to cart',
        'whatsapp_contact': 'Contact us on WhatsApp',

        'product_viewDetails': 'View details',
        'product_outOfStock': 'Out of stock',
        'product_no_offer': 'This product is no longer part of our store offer',
        'product_promo': 'Promo',
        "product_additional_info": "Additional information",
        'product_type': 'Type',
        'product_description': 'Description',
        'product_short_description': 'View all description',
        'product_specifications': 'Specifications',
        'item_code': 'Item code: ',
        'consumables_compatible': 'Compatible consumables',
        'recommendations': 'Recommendations',
        'compatible_accessories': 'Compatible accessories',

        'price_vat_included': 'VAT included',
        'request_a_quote': 'Request a quote',
        'request_product_quote': 'Request product quote',

        'btn_hide_info': 'Hide info',
        'btn_show_info': 'Show more',

        'reviews': 'Reviews',
        'review_write': 'Write a review',
        'review_write_for': 'Write a review for: ',
        'product_review_rating': 'Rate the product: ',
        'review_string1': 'Do you own or have you used the product?',
        'review_string2': 'Your opinion can help other customers.',
        'review_rating_required': 'Please select a rating!',
        'review_username_label': 'Username: ',
        'review_username_required': 'Username is required',
        'review_username_length1': 'Please enter less than 30 characters',
        'review_username_length2': 'Please enter less than 50 characters',
        'review_username_placeholder': 'Your username',
        'review_title_label': 'Review title: ',
        'review_title_required': 'This field is required',
        'review_content_label': 'Review: ',
        'review_content_limit': 'The limit is 1000 characters',
        'review_content_placeholder': 'Describe your experience with the product',
        'review_submit_button': 'Submit review',
        'review_form_expand': 'Show form',
        'review_form_collapse': 'Hide form',
        'review_success_title': 'Thank you!',
        'review_success_message': 'Your review has been submitted!',
        'review_close_modal': 'Close',

        'contacts_title': 'Contact us by phone for price or details',
        'contacts_callback_info': 'You can direct the call to the representative of your geographical area',
        'contacts_parts_info': 'Online parts sales',
        'contacts_general_sales': 'Online sales (garden machinery, power tools and tools)',
        'contacts_tenders': 'Tenders or public procurement',
        'contacts_complaints': 'Complaints and Suggestions',
        'contacts_consulting': 'Free internal consulting',

        //general
        'shipping_cost': 'Shipping cost{setup}: {value} {currency} VAT included (anywhere in the country).',
        'shipping_install': ' and installation',
        'get_file': 'Get file',
        'loading': 'Loading...',

        //sidebar
        'advantages_warranty': 'Warranty',
        'advantages_warranty_5years': 'This product comes with a 5-YEAR warranty (for both individuals and companies).',
        'advantages_warranty_standard': 'This product comes with a 24-month warranty for individuals and 12 months for companies.',
        'advantages_service': 'Authorized service',
        'advantages_service_description': 'Costica is authorized to repair under warranty and post-warranty the products it sells.',
        'see_brand_products': 'See brand products',
        'manual_download_button': 'Download manual',
        'manual_download_tooltip': 'Download product manual',
        'technical_sheet_button': 'Technical sheet',
        'technical_sheet_tooltip': 'Download technical sheet.',


        //toolbar
        'description': 'Description',
        "aditionat_info": "Additional information",
        'related_products': 'Similar products',
        'technical_specs': 'Technical specifications',
        'associated_products': 'Associated products',
        'accessories': 'Accessories',

        //safety stihl
        'safety_measures': 'safety measures',
        'safety_info': 'To understand the dangers of a chainsaw, training is required.',
        'safety_clothing': 'Safety clothing requirements must also be met.',
        'safety_clarification': 'If the information is unclear, we recommend picking it up from our physical store (authorized STIHL dealer).',
        'safety_more_info': 'More information on the',
        'youtube_channel': 'YouTube Stihl Romania',

        //seap
        'present_on': 'We are present on',
        'seap_system': 'Electronic Public Procurement System',
        'seap_request': 'Request posting on SEAP',
        'seap_request_form_title': 'Request for SEAP posting',

        'request_information': 'Request information',
        'add_to_cart': 'Add to cart',
        'request_quote_for_product': 'Request quote for product',
        'product_not_in_store': 'This product is no longer part of our store offer',
        'crm_form_success': 'Your request has been successfully sent. We will contact you as soon as possible. Thank you!',
        'crm_form_error': 'Sorry, there was a problem sending your message. Please use the available phone numbers.',
        'crm_form_required_fields': 'Last name, first name, email, phone, region and productSku are required fields.',

        // Form fields
        'form_lastname': 'Last name *',
        'form_lastname_required': 'Last name is required',
        'form_lastname_max': 'Maximum 30 characters',
        'form_firstname': 'First name *',
        'form_firstname_required': 'First name is required',
        'form_firstname_max': 'Maximum 30 characters',
        'form_email': 'Email *',
        'form_email_required': 'This field is required',
        'form_email_invalid': 'Invalid email address',
        'form_email_max': 'Maximum 100 characters',
        'form_phone': 'Phone number *',
        'form_phone_required': 'This field is required',
        'form_phone_invalid': 'Please enter a valid phone number',
        'form_phone_min': 'Please enter a valid phone number',
        'form_phone_max': 'Please enter a valid phone number',
        'form_region': 'City/Region/Country *',
        'form_region_required': 'Please enter your city, region or country',
        'form_message': 'Your message ... (optional)',
        'form_message_max': 'Please enter less than 200 characters',
        'form_submit': 'Submit request',
        'form_submitting': 'Submitting...',
        'form_close': 'Close',
        'form_select_subject': 'Select a subject:',
        'form_subject_required': 'Subject selection is required',
        'form_send_message': 'Send us a message:',

        // Footer
        'footer_we_are_present': 'We are present here too',
        'footer_alternative_dispute': 'Alternative dispute resolution procedures',
        'footer_operational_program': 'Operational Sector Program "Increasing Economic Competitiveness"',
        'footer_priority_axis': 'Priority axis 3: Information and communication technology (ICT) for the private and public sectors',
        'footer_invest_future': '"Invest for your future" E-commerce platform - sales efficiency',
        'footer_company': 'at S.C. Keiron Logistics S.R.L.',
    },
    ro: {
        'cart_addToCart': 'Adauga în cos',
        'whatsapp_contact': 'Contactați-ne pe WhatsApp',

        'product_viewDetails': 'Vezi detalii',
        'product_outOfStock': 'Stoc epuizat',
        'product_no_offer': 'Acest produs nu mai face parte din oferta magazinului nostru',
        'product_promo': 'Promo',
        "product_additional_info": "Informatii aditionale",
        'product_type': 'Tip produs',
        'product_description': 'Prezentare',
        'product_short_description': 'Vezi toata descrierea',
        'product_specifications': 'Specificatii tehnice',
        'item_code': 'Cod articol: ',
        'consumables_compatible': 'Consumabile compatibile',
        'recommendations': 'Recomandari',
        'compatible_accessories': 'Accesorii compatibile',

        'price_vat_included': 'TVA inclus',
        'request_a_quote': 'Cere o oferta',
        'request_product_quote': 'Cere o oferta pentru produs',

        'btn_hide_info': 'Ascunde info',
        'btn_show_info': 'Vezi mai multe',

        'reviews': 'Evaluari',
        'review_write': 'Scrie o evaluare',
        'review_write_for': 'Scrie o evaluare pentru: ',
        'product_review_rating': 'Acorda un rating produsului: ',
        'review_string1': 'Detii sau ai folosit produsul?',
        'review_string2': 'Parerea ta ii poate ajuta pe ceilalti clienti.',
        'review_rating_required': 'Te rugam să selectezi un rating!',
        'review_username_label': 'Nume utilizator: ',
        'review_username_required': 'Nume utilizator este obligatoriu',
        'review_username_length1': 'Te rugam sa introduci mai putin de 30 caractere',
        'review_username_length2': 'Te rugam sa introduci mai putin de 50 caractere',
        'review_username_placeholder': 'Numele tau de utilizator',
        'review_title_label': 'Titlu evaluare: ',
        'review_title_required': 'Acest camp este obligatoriu',
        'review_content_label': 'Evaluare: ',
        'review_content_limit': 'Limita este de 1000 caractere',
        'review_content_placeholder': 'Descrie experienta ta cu produsul',
        'review_submit_button': 'Trimite evaluarea',
        'review_form_expand': 'Vezi formularul',
        'review_form_collapse': 'Ascunde formularul',
        'review_success_title': 'Multumim!',
        'review_success_message': 'Evaluarea dv a fost trimisa!',
        'review_close_modal': 'Inchide',

        'contacts_title': 'Contacteaza-ne telefonic pentru pret sau detalii',
        'contacts_callback_info': 'Vei putea directiona apelul catre reprezentantul zonei geografice din care faci parte',
        'contacts_parts_info': 'Vanzari online piese',
        'contacts_general_sales': 'Vanzari online (utilaje gradina, motoutilaje si unelte)',
        'contacts_tenders': 'Licitatii sau achizitii publice',
        'contacts_complaints': 'Reclamatii si Sugestii',
        'contacts_consulting': 'Consiliere gratuita interna',

        //general
        'shipping_cost': 'Cost livrare{setup}: {value} {currency} cu TVA inclus (oriunde in tara).',
        'shipping_install': ' si punere in functiune',
        'get_file': 'Descarca fisierul',
        'loading': 'Se incarca...',

        //sidebar
        'advantages_warranty': 'Garanție',
        'advantages_warranty_5years': 'La acest produs aveți garanție 5 ANI (atât pentru persoane fizice cât și pentru persoane juridice).',
        'advantages_warranty_standard': 'La acest produs aveți garanție 24 de luni pentru persoane fizice și 12 luni pentru persoane juridice.',
        'advantages_service': 'Service autorizat',
        'advantages_service_description': 'Costica este autorizat să îți repare în garanție și post garanție produsele ce le comercializează.',
        'see_brand_products': 'Vezi produsele brandului',
        'manual_download_button': 'Descarcă manual',
        'manual_download_tooltip': 'Descarcă manualul produsului',
        'technical_sheet_button': 'Fișă tehnică',
        'technical_sheet_tooltip': 'Descarcă fișa tehnică.',

        //toolbar
        'description': 'Descriere',
        "aditionat_info": "Informații adiționale",
        'related_products': 'Produse similare',
        'technical_specs': 'Specificatii tehnice',
        'associated_products': 'Produse asociate',
        'accessories': 'Accesorii',

        //safety stihl
        'safety_measures': 'masuri de siguranta',
        'safety_info': 'Pentru a cunoaște pericolele unui motofierăstrău, este necesară o instruire.',
        'safety_clothing': 'De asemenea, trebuie respectate cerințele pentru îmbrăcămintea de siguranță.',
        'safety_clarification': 'Dacă informațiile nu sunt clare, vă recomandăm să-l ridicați din magazinul nostru fizic (dealer autorizat STIHL).',
        'safety_more_info': 'Mai multe informații pe canalul de',
        'youtube_channel': 'YouTube Stihl Romania',

        //seap
        'present_on': 'Suntem prezenți pe',
        'seap_system': 'Sistemul Electronic de Achiziții Publice',
        'seap_request': 'Cere postarea pe SEAP',
        'seap_request_form_title': 'Cerere postare SEAP',

        'request_information': 'Cere informatii',
        'add_to_cart': 'Adauga in cos',
        'request_quote_for_product': 'Cere oferta pentru produs',
        'product_not_in_store': 'Acest produs nu mai face parte din oferta Magaziei',
        'crm_form_success': 'Cererea dvs a fost trimisă cu succes. Vă vom contacta în cel mai scurt timp. Mulțumim!',
        'crm_form_error': 'Ne pare rău, există o problemă la trimiterea mesajului. Vă rugăm folosiți numerele de telefon disponibile.',
        'crm_form_required_fields': 'Numele, prenumele, email-ul, telefonul, regiunea și codul produsului sunt câmpuri obligatorii.',

        // Form fields
        'form_lastname': 'Nume *',
        'form_lastname_required': 'Numele este obligatoriu',
        'form_lastname_max': 'Maxim 30 caractere',
        'form_firstname': 'Prenume *',
        'form_firstname_required': 'Prenumele este obligatoriu',
        'form_firstname_max': 'Maxim 30 caractere',
        'form_email': 'Email *',
        'form_email_required': 'Acest camp este obligatoriu',
        'form_email_invalid': 'Adresa de email invalidă',
        'form_email_max': 'Maxim 100 caractere',
        'form_phone': 'Numar telefon *',
        'form_phone_required': 'Acest camp este obligatoriu',
        'form_phone_invalid': 'Te rugam sa introduci un nr de telefon valid.',
        'form_phone_min': 'Te rugam sa introduci un nr de telefon valid.',
        'form_phone_max': 'Te rugam sa introduci un nr de telefon valid.',
        'form_region': 'Alege Județul',
        'form_region_required': 'Selectarea unui județ este obligatorie',
        'form_message': 'Mesajul tau ... (optional)',
        'form_message_max': 'Te rugam sa introduci mai putin de 200 caractere.',
        'form_submit': 'Trimite cererea',
        'form_submitting': 'Se trimite...',
        'form_close': 'Închide',
        'form_select_subject': 'Selecteaza un subiect:',
        'form_subject_required': 'Selectarea unui subiect este obligatorie',
        'form_send_message': 'Trimite-ne un mesaj:',

        // Footer
        'footer_we_are_present': 'Suntem prezenti si aici',
        'footer_alternative_dispute': 'Proceduri de soluționare alternativă a litigiilor',
        'footer_operational_program': 'Programul Operational Sectorial "Cresterea Competivitatii Economice"',
        'footer_priority_axis': 'Axa prioritara 3: Tehnologia informatiei si comunicatiilor (TIC) pentru sectoarele privat si public',
        'footer_invest_future': '"Investiti pentru viitorul dumneavoastra" Platforma e-commerce - eficienta in vanzari',
        'footer_company': 'la S.C. Keiron Logistics S.R.L.',
    },
    hu: {
        'cart_addToCart': 'Kosárba',
        'whatsapp_contact': 'Lépjen kapcsolatba velünk WhatsApp-on',

        'product_viewDetails': 'Részletek',
        'product_outOfStock': 'Elfogyott',
        'product_no_offer': 'Ez a termék már nem része kínálatunknak',
        'product_promo': 'Akció',
        "product_additional_info": "További információk",
        'product_type': 'Termék típus',
        'product_description': 'Leírás',
        'product_specifications': 'Műszaki adatok',
        'product_short_description': 'Összes leírás megtekintése',
        'item_code': 'Cikkszám: ',
        'consumables_compatible': 'Kompatibilis fogyóeszközök',
        'recommendations': 'Ajánlások',
        'compatible_accessories': 'Kompatibilis kiegészítők',

        'price_vat_included': 'ÁFA-val',
        'request_a_quote': 'Árajánlat kérése',
        'request_product_quote': 'Árajánlat kérése a termékhez',

        'btn_hide_info': 'Elrejtés',
        'btn_show_info': 'További információk',

        'reviews': 'Értékelések',
        'review_write': 'Értékelés írása',
        'review_write_for': 'Értékelés írása ehhez: ',
        'product_review_rating': 'Termék értékelése: ',
        'review_string1': 'Birtokolja vagy használta a terméket?',
        'review_string2': 'Véleménye segíthet más vásárlóknak.',
        'review_rating_required': 'Kérjük, válasszon értékelést!',
        'review_username_label': 'Felhasználónév: ',
        'review_username_required': 'A felhasználónév kötelező',
        'review_username_length1': 'Kérjük, 30 karakternél kevesebbet írjon be',
        'review_username_length2': 'Kérjük, 50 karakternél kevesebbet írjon be',
        'review_username_placeholder': 'Az Ön felhasználóneve',
        'review_title_label': 'Értékelés címe: ',
        'review_title_required': 'Ez a mező kötelező',
        'review_content_label': 'Értékelés: ',
        'review_content_limit': 'A limit 1000 karakter',
        'review_content_placeholder': 'Írja le tapasztalatait a termékkel',
        'review_submit_button': 'Értékelés küldése',
        'review_form_expand': 'Űrlap mutatása',
        'review_form_collapse': 'Űrlap elrejtése',
        'review_success_title': 'Köszönjük!',
        'review_success_message': 'Értékelését elküldtük!',
        'review_close_modal': 'Bezárás',

        'contacts_title': 'Hívjon minket az árért vagy részletekért',
        'contacts_callback_info': 'A hívást átirányíthatja a földrajzi területének képviselőjéhez',
        'contacts_parts_info': 'Online alkatrész értékesítés',
        'contacts_general_sales': 'Online értékesítés (kerti gépek, elektromos szerszámok és szerszámok)',
        'contacts_tenders': 'Tender vagy közbeszerzés',
        'contacts_complaints': 'Panaszok és javaslatok',
        'contacts_consulting': 'Ingyenes belső tanácsadás',

        //general
        'shipping_cost': 'Szállítási költség{setup}: {value} {currency} ÁFÁ-val (bárhol az országban).',
        'shipping_install': ' és üzembe helyezés',
        'get_file': 'Fájl letöltése',
        'loading': 'Betöltés...',

        //sidebar
        'advantages_warranty': 'Garancia',
        'advantages_warranty_5years': 'Erre a termékre 5 ÉV garanciát vállalunk (mind magánszemélyek, mind cégek számára).',
        'advantages_warranty_standard': 'Erre a termékre magánszemélyek részére 24 hónap, cégek részére 12 hónap garanciát vállalunk.',
        'advantages_service': 'Hivatalos szerviz',
        'advantages_service_description': 'A Costica jogosult a forgalmazott termékek garanciális és garancia utáni javítására.',
        'see_brand_products': 'Lásd a márka termékeit',
        'manual_download_button': 'Kézikönyv letöltése',
        'manual_download_tooltip': 'Termék kézikönyv letöltése',
        'technical_sheet_button': 'Műszaki adatlap',
        'technical_sheet_tooltip': 'Műszaki adatlap letöltése.',

        //toolbar
        'description': 'Leírás',
        "aditionat_info": "További adatok",
        'related_products': 'Hasonló termékek',
        'technical_specs': 'Műszaki adatok',
        'associated_products': 'Kapcsolódó termékek',
        'accessories': 'Kiegészítők',

        //safety stihl
        'safety_measures': 'biztonsági intézkedések',
        'safety_info': 'A láncfűrész veszélyeinek megértéséhez képzés szükséges.',
        'safety_clothing': 'Meg kell felelni a biztonsági ruházati követelményeknek is.',
        'safety_clarification': 'Ha az információk nem egyértelműek, javasoljuk, hogy személyesen vegye át fizikai üzletünkben (STIHL hivatalos forgalmazó).',
        'safety_more_info': 'További információk a',
        'youtube_channel': 'YouTube Stihl Románia',

        //seap
        'present_on': 'Jelen vagyunk a',
        'seap_system': 'Elektronikus Közbeszerzési Rendszer',
        'seap_request': 'Kérje a SEAP-on történő közzétételt',
        'seap_request_form_title': 'Kérelem a SEAP-on történő közzétételhez',

        'request_information': 'Információ kérése',
        'add_to_cart': 'Kosárba',
        'request_quote_for_product': 'Árajánlat kérése a termékhez',
        'product_not_in_store': 'Ez a termék már nem része az áruház kínálatának',
        'crm_form_success': 'Kérését sikeresen elküldtük. A lehető leghamarabb felvesszük Önnel a kapcsolatot. Köszönjük!',
        'crm_form_error': 'Sajnáljuk, probléma merült fel az üzenet küldése során. Kérjük, használja a rendelkezésre álló telefonszámokat.',
        'crm_form_required_fields': 'A vezetéknév, keresztnév, e-mail, telefon, régió és termékkód kötelező mezők.',

        // Form fields
        'form_lastname': 'Vezetéknév *',
        'form_lastname_required': 'A vezetéknév kötelező',
        'form_lastname_max': 'Maximum 30 karakter',
        'form_firstname': 'Keresztnév *',
        'form_firstname_required': 'A keresztnév kötelező',
        'form_firstname_max': 'Maximum 30 karakter',
        'form_email': 'E-mail *',
        'form_email_required': 'Ez a mező kötelező',
        'form_email_invalid': 'Érvénytelen e-mail cím',
        'form_email_max': 'Maximum 100 karakter',
        'form_phone': 'Telefonszám *',
        'form_phone_required': 'Ez a mező kötelező',
        'form_phone_invalid': 'Kérjük, adjon meg érvényes telefonszámot',
        'form_phone_min': 'Kérjük, adjon meg érvényes telefonszámot',
        'form_phone_max': 'Kérjük, adjon meg érvényes telefonszámot',
        'form_region': 'Város/Régió/Ország *',
        'form_region_required': 'Kérjük, adja meg városát, régióját vagy országát',
        'form_message': 'Az Ön üzenete ... (opcionális)',
        'form_message_max': 'Kérjük, adjon meg kevesebb mint 200 karaktert',
        'form_submit': 'Kérelem küldése',
        'form_submitting': 'Küldés...',
        'form_close': 'Bezárás',
        'form_select_subject': 'Válasszon témát:',
        'form_subject_required': 'A téma kiválasztása kötelező',
        'form_send_message': 'Küldjön üzenetet:',

        // Footer
        'footer_we_are_present': 'Itt is jelen vagyunk',
        'footer_alternative_dispute': 'Alternatív vitarendezési eljárások',
        'footer_operational_program': 'Operatív Ágazati Program "A gazdasági versenyképesség növelése"',
        'footer_priority_axis': '3. prioritási tengely: Információs és kommunikációs technológia (IKT) a magán- és állami szektorok számára',
        'footer_invest_future': '"Fektessen be a jövőjébe" E-kereskedelmi platform - értékesítési hatékonyság',
        'footer_company': 'a S.C. Keiron Logistics S.R.L.-nél',
    }
};

declare global {
    interface Window {
        STORE_LOCALE: string;
        STORE_ID: number;
        STORE_CODE: string;
        currencySymbol: string;
    }
}

interface CurrencyContextType {
    currencySymbol: string;
    locale: string;
    storeId: number;
    formatPrice: (price: number) => string;
}

const CurrencyContext = createContext<CurrencyContextType>({
    currencySymbol: '',
    locale: 'ro',
    storeId: 1,
    formatPrice: (price) => price.toString()
});

export const useTranslation = () => useContext(CurrencyContext);

export const TranslationsProvider = ({children}) => {
    const [locale, setLocale] = useState('ro');
    const [currencySymbol, setCurrencySymbol] = useState<string>('');
    const [storeId, setStoreId] = useState<number>(1);

    const formatPrice = (price: number): string => {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencySymbol || 'RON',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(price);
    };

    useEffect(() => {
        let detectedLocale = window.STORE_LOCALE?.split('_')[0] || 'ro';
        
        // Treat 'default' locale as 'ro'
        if (detectedLocale === 'default') {
            detectedLocale = 'ro';
        }
        
        setLocale(detectedLocale);
        setCurrencySymbol(window.currencySymbol || 'RON');
        setStoreId(window.STORE_ID || 1);

        if (window.currencySymbol) {
            setCurrencySymbol(window.currencySymbol);
        }
    }, []);

    const currencyContextValue = {
        currencySymbol,
        locale,
        storeId,
        formatPrice
    };

    // console.log('locale', locale);
    // console.log('currencySymbol', currencySymbol);

    return (
        <CurrencyContext.Provider value={currencyContextValue}>
            <IntlProvider messages={messages[locale]} locale={locale}>
                {children}
            </IntlProvider>
        </CurrencyContext.Provider>
    );
};
